import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {
  ApiController,
  ApiExecutor,
  ApiResponse,
  ApiValidationService,
  Body,
  DELETE,
  GET,
  Header,
  PATCH,
  POST,
  PUT,
  Params,
  Query,
} from '@app/core/api';
import {CreateContactRequestDto} from '../dto/create-contact-request.dto';
import {ExcelSecondStepRequestDto} from '../dto/excel-second-step-request.dto';
import {FileConfirmRequestDto} from '../dto/file-confirm-request.dto';
import type {
  BulkPreviewModel,
  ContactDetailModel,
  ContactsInGroupPageModel,
  ContactsInGroupQuery,
  ExcelFirstStepModel,
} from './contacts-api.models';

@ApiController('api/app/contact-group')
@Injectable({providedIn: 'root'})
export class ContactsApiService {
  constructor(
    public apiExecutor: ApiExecutor,
    public apiValidationService: ApiValidationService,
  ) {}

  @GET('/:groupId/contact')
  listContacts(
    @Params('groupId') groupId: number,
    @Query() query: ContactsInGroupQuery,
  ): Observable<ApiResponse<ContactsInGroupPageModel>> {
    return {} as Observable<ApiResponse<ContactsInGroupPageModel>>;
  }

  @GET('/:groupId/contact/:contactId')
  getContact(
    @Params('groupId') groupId: number,
    @Params('contactId') contactId: number,
  ): Observable<ApiResponse<ContactDetailModel>> {
    return {} as Observable<ApiResponse<ContactDetailModel>>;
  }

  @POST('/:groupId/contact')
  createContact(
    @Params('groupId') groupId: number,
    @Body() body: CreateContactRequestDto,
  ): Observable<ApiResponse<boolean>> {
    return {} as Observable<ApiResponse<boolean>>;
  }

  @PUT('/:groupId/contact/:contactId')
  updateContact(
    @Params('groupId') groupId: number,
    @Params('contactId') contactId: number,
    @Body() body: CreateContactRequestDto,
  ): Observable<ApiResponse<boolean>> {
    return {} as Observable<ApiResponse<boolean>>;
  }

  @DELETE('/:groupId/contact/:contactId')
  deleteFromGroup(
    @Params('groupId') groupId: number,
    @Params('contactId') contactId: number,
  ): Observable<ApiResponse<boolean>> {
    return {} as Observable<ApiResponse<boolean>>;
  }

  @POST('/:groupId/contact/bulk')
  bulkPreview(
    @Params('groupId') groupId: number,
    @Body() mobiles: number[],
  ): Observable<ApiResponse<BulkPreviewModel>> {
    return {} as Observable<ApiResponse<BulkPreviewModel>>;
  }

  @PATCH('/:groupId/contact/bulk')
  @Header({'Content-Type': 'application/json'})
  bulkConfirm(
    @Params('groupId') groupId: number,
    @Body() key: string,
  ): Observable<ApiResponse<boolean>> {
    return {} as Observable<ApiResponse<boolean>>;
  }

  @POST('/:groupId/contact/text')
  textUpload(
    @Params('groupId') groupId: number,
    @Body() formData: FormData,
  ): Observable<ApiResponse<BulkPreviewModel>> {
    return {} as Observable<ApiResponse<BulkPreviewModel>>;
  }

  @POST('/:groupId/contact/excel/first-step')
  excelFirstStep(
    @Params('groupId') groupId: number,
    @Body() formData: FormData,
  ): Observable<ApiResponse<ExcelFirstStepModel>> {
    return {} as Observable<ApiResponse<ExcelFirstStepModel>>;
  }

  @POST('/:groupId/contact/excel/second-step')
  excelSecondStep(
    @Params('groupId') groupId: number,
    @Body() body: ExcelSecondStepRequestDto,
  ): Observable<ApiResponse<BulkPreviewModel>> {
    return {} as Observable<ApiResponse<BulkPreviewModel>>;
  }

  @PATCH('/:groupId/contact/file')
  fileConfirm(
    @Params('groupId') groupId: number,
    @Body() body: FileConfirmRequestDto,
  ): Observable<ApiResponse<boolean>> {
    return {} as Observable<ApiResponse<boolean>>;
  }
}

@ApiController('api/app/contact')
@Injectable({providedIn: 'root'})
export class ContactSystemApiService {
  constructor(
    public apiExecutor: ApiExecutor,
    public apiValidationService: ApiValidationService,
  ) {}

  @GET()
  listContacts(@Query() query: ContactsInGroupQuery): Observable<ApiResponse<ContactsInGroupPageModel>> {
    return {} as Observable<ApiResponse<ContactsInGroupPageModel>>;
  }

  @DELETE('/:contactId')
  deleteFromSystem(@Params('contactId') contactId: number): Observable<ApiResponse<boolean>> {
    return {} as Observable<ApiResponse<boolean>>;
  }
}
